module.exports = __webpack_public_path__ + "img/sort_up.1de52b1a.svg";